import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import ExportHelper from '../chart_helpers/ExportHelper'
import { geoPath as d3_geoPath } from 'd3-geo'
import { select as d3_select} from 'd3-selection'
import * as COLORS from '../utils/colorUtils'

import {
  geoMiller as d3_geoMiller,
} from 'd3-geo-projection'
import {zoom as d3_zoom } from 'd3-zoom'
const projections = {
  d3_geoMiller,
}
// import geojson from '../data/geojson/spain.geo.json'
import SizeHelper from '../chart_helpers/SizeHelper'

export default class ChoroplethChart extends BaseChart {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: 'sequential2',
      colorKey: 'value',
    },
    /**
     * List of geojson `features` to be drawn. See [maps](#/developer/PropDetails#features).
     */
    features: {
      type: [Array, null],
      default: null,
      exposed: true,
    },
    /**
     * Name of the Id property in the `features`. See [maps](#/developer/PropDetails#valueFormat).
     */
    featureIdProperty: {
      type: String,
      default: 'id',
      exposed: true,
    },
    /**
     * Name of the Label property in the `features`. See [maps](#/developer/PropDetails#valueFormat).
     */
    featureLabelProperty: {
      type: String,
      default: 'name',
      exposed: true,
    },
    /**
     * List of displaced `features` to be shown in a separate box. See [maps](#/developer/PropDetails#valueFormat).
     */
    displacedFeatures: {
      type: Array,
      default: [],
      exposed: true,
    },
    /**
     * Name of a d3 projection function or custom projection function. See [maps](#/developer/PropDetails#valueFormat).
     */
    projection: {
      type: [String, Function],
      default: 'd3_geoMiller',
      exposed: true,
    },
    showZoomControls: {
      type: Boolean,
      default: true,
      exposed: true,
    }
  }

  static helpers = [RootHelper, ItemsHelper, SizeHelper, SelectableHelper, ExportHelper]
  beforeHelpers() {
    // this.content = this.root.selectAll('.content').data([null])
    // this.content = this.content.merge(this.content.enter().append('g').attr('class','content'))
    // this.content.attr('transform',`translate(${this.size.width/2},${this.size.height/2})`)
  }
  draw() {

    let background = this.content.selectAll('.background').data([null])
    background = background.merge(background.enter().append('rect').attr('class','background'))
    background.attr('fill','none').attr('width',this.size.width).attr('height',this.size.height).lower()

    let features = this.config.features
    let featureIdProperty = this.config.featureIdProperty
    let specialRegions = this.config.displacedFeatures || [] //['USA-3563','USA-3517']

    let regionGroups = {
      default: {
        type: 'FeatureCollection',
        features: features.filter(f => specialRegions.indexOf(f.properties[featureIdProperty]) < 0),
      },
      ...specialRegions.reduce((ob, id) => {
        ob[id] = features.find(f => f.properties[featureIdProperty] === id)
        return ob
      }, {}),
    }
    let defaultMargin = 20
    let defaultSize = { width: this.size.width, height: this.size.height - defaultMargin }

    let short = Math.min(this.size.width, this.size.height)
    let boxWidth = Object.keys(regionGroups).length > 1 ? short * 0.24 : 0
    let boxMargin = Object.keys(regionGroups).length > 1 ? short * 0.08 : 0

    let totalBoxWidth = boxWidth + 2 * boxMargin

    let paths = Object.keys(regionGroups).reduce((result, key, i) => {
      let extent

      if (key === 'default')
        extent = [
          [boxWidth, defaultMargin],
          [defaultSize.width, defaultSize.height],
        ]
      else
        extent = [
          [totalBoxWidth * (i - 1) + boxMargin, defaultSize.height - boxWidth],
          [totalBoxWidth + totalBoxWidth * (i - 1), defaultSize.height],
        ]
      let projFunc =
        typeof this.config.projection === 'function'
          ? this.config.projection
          : projections[this.config.projection] || projections['d3_geoMercator']

      let proj = projFunc().fitExtent(extent, regionGroups[key])
      result[key] = d3_geoPath(proj)
      return result
    }, {})
    this.itemsExitTrans.style('opacity', '0')
    this.itemsEnter.append('path').attr('vector-effect', 'non-scaling-stroke')
    this.itemsEnter.select('path').attr('fill', '#ddd')

    //reseteamos la "chapuza" del "tooltipBehavior.getItemOffset" con boundingPath
    this.items.each(function(){this.boundingPath=null})

    this.itemsEnterTrans
      .select('path')
      .attr('fill', d => (this._colorKey(d) ? this.color(d) : 'rgba(200,200,200,0.35)'))
      // .attr('stroke', 'transparent')
    this.itemsTrans
      .select('path')
      .attr('fill', d => (this._colorKey(d) ? this.color(d) : 'rgba(200,200,200,0.35)'))

    // this.items.merge(this.itemsEnter).select('path')
    this.itemsEnter.select('path').attr('d', d => {
      let f = features.find(f => f.properties[featureIdProperty] === d.id)
      return (paths[d.id] ? paths[d.id] : paths.default)(f)
    })
    this.itemsTrans
      .select('path')
      .attr('d', d => {
        let f = features.find(f => f.properties[featureIdProperty] === d.id)
        return (paths[d.id] ? paths[d.id] : paths.default)(f)
      })
    // .attr(
    //   'stroke',
    //   this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
    // )
    const zoom = d3_zoom().scaleExtent([1, 18]).on('zoom',(e)=>{
      this.content.selectAll('path')
        .attr('transform', e.transform)
    })
    this.content.call(zoom)
    
    if(this.config.showZoomControls){
      let zoomButtons = d3_select(this.root.node().parentNode).selectAll('.zoom-buttons').data([null])
      zoomButtons = zoomButtons.merge(zoomButtons.enter().append('div').attr('class','zoom-buttons'))
      zoomButtons.style('position','absolute').style('bottom', '0px').style('right', '0px').style('display','flex').style('flex-direction','column')
      let buttons = zoomButtons.selectAll('.z-btn').data(['+','-'])
      let buttonsEnter =buttons.enter().append('div').attr('class','z-btn')
      buttonsEnter.append('div').text((d)=>d)
        .style('position','absolute')
        .style('top','50%')
        .style('left','50%')
        .style('transform','translate(-50%,-50%)')
      buttons = buttons.merge(buttonsEnter)
      buttons
        .style('width','30px')
        .style('height','30px')
        .style('border','solid 1px #828282')
        .style('border-radius','3px')
        .style('margin','5px')
        .style('position','relative')
        .style('background','#fff')
        .style('cursor','pointer')
      buttons.on('click',(e,d)=>{
        zoom.scaleBy(this.content.transition().duration(400), d==='+' ? 1.6 : 1/1.6)
      })
    }
  }

  getLegendData() {
    if (this.config.ItemsHelper.colorScale === 'categorical') {
      let legendData = {}
      let categories = this.data.reduce((res, d) => {
        res.push(d[this.config.ItemsHelper.colorKey])
        return res
      }, [])
      categories = categories.filter((d, i) => categories.indexOf(d) === i)
      let categoryData = categories.map(g => {
        return { id: g, category: g }
      })
      legendData.category = categoryData
      legendData.category.icon = 'circle'
      return legendData
    } else {
      return null
    }
  }
  setSelectedFunc(sel) {
    // console.log("should set hightliht",d,this)
    // sel.style('opacity', 1)
    sel.style('stroke', '#888')
    sel.style('stroke-width', 1)
  }
  unsetSelectedFunc(sel) {
    // console.log("should unset hightliht",d,this)
    // sel.style('opacity', 1)
    sel.style('stroke', 'none')
  } 
}
